import { isEmpty } from '@/shared/util';

import { errorInterceptorHandler } from '../../utils';
import { createApiError } from './api-error.util';

export const isStreamingContentType = (contentType: null | string): boolean => {
  if (isEmpty(contentType)) {
    return false;
  }

  return (
    contentType.includes('text/event-stream') ||
    contentType.includes('application/x-ndjson') ||
    contentType.includes('text/stream')
  );
};

export const isStreamingRequest = (headers?: HeadersInit): boolean => {
  if (!headers) {
    return false;
  }

  if (headers instanceof Headers) {
    const acceptHeader = headers.get('accept');

    return acceptHeader?.toLowerCase().includes('text/event-stream') ?? false;
  }

  if (Array.isArray(headers)) {
    return headers.some(
      ([key, value]) =>
        key.toLowerCase() === 'accept' && value.toLowerCase().includes('text/event-stream'),
    );
  }

  return Object.entries(headers).some(
    ([key, value]) =>
      key.toLowerCase() === 'accept' && value.toLowerCase().includes('text/event-stream'),
  );
};

export const handleStreamingResponse = async (
  response: Response,
  url: string,
): Promise<Response> => {
  if (!response.ok) {
    const error = createApiError({
      message: `Request failed with status ${response.status}`,
      response,
      url,
    });

    await errorInterceptorHandler(error);

    throw error;
  }

  return response;
};
